<template>
  <div class="survey-page">
    <main class="survey-content">
       <div class="page-top">
            <img src="@/assets/image/share/page-top.png" alt="">
        </div>
        <div class="form-content">
            <section class="notice-card">
                <div class="notice-bg">
                    <img src="@/assets/image/share/center-logo.png" alt="">
                </div>
                <div class="notice-title"><div class="notice-title-text">调查服务时间范围：{{ serviceDateRange }}</div></div>
                <div class="notice-bottom"></div>
                <div class="notice-body">
                    <p>尊敬的客户您好：</p>
                    <p>为持续优化我司物流服务品质，完善服务质量管理体系，进一步提升运输、对接及售后综合服务能力，更好地匹配贵司业务需求，现诚挚邀请您对我司近期的物流产品与服务开展评价。烦请您结合实际合作体验完成本次满意度调查，并对我们服务中存在的不足提出宝贵改进意见，助力我们持续改进提升。感谢贵司一直以来的信任与支持！</p>
                </div>
            </section>
            <section class="basic-form">
                <div class="center-line">
                    <svg xmlns="http://www.w3.org/2000/svg" width="344" height="1" viewBox="0 0 344 1" fill="none">
                        <path d="M0.5 0.5H343.5" stroke="black" stroke-linecap="round" stroke-dasharray="5 8"/>
                    </svg>
                </div>
                <label v-for="(field, index) in basicFields" :key="field.key" class="form-item">
                <span class="question"><i>*</i>{{ index + 1 }}.{{ field.label }}</span>
                <input
                    v-model.trim="form[field.key]"
                    :type="field.type || 'text'"
                    :placeholder="field.placeholder"
                    :maxlength="field.maxlength"
                >
                </label>
            </section>
        </div>

      
    </main>

    <footer class="page-footer">
      <button type="button" class="primary-button" :disabled="!surveyValid || loading" @click="nextPage">下一页</button>
    </footer>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getSurveyDateDetail } from '@/api/beecargo/satisfactionSurvey/index';

const STORAGE_KEY = 'beecargo-satisfaction-survey';

export default {
  name: 'SatisfactionSurvey',
  data() {
    return {
      basicFields: [
        { key: 'companyName', label: '您的公司', placeholder: '请输入公司名', maxlength: 50 },
        { key: 'customerName', label: '您的名字', placeholder: '请输入您的姓名', maxlength: 30 },
        { key: 'phone', label: '您的手机号码', placeholder: '请输入您的手机号码', type: 'tel', maxlength: 11 }
      ],
      form: {
        companyName: '',
        customerName: '',
        phone: ''
      },
      surveyValid: false,
      loading: false,
      surveyInfo: {
        serviceStartMonth: '',
        serviceEndMonth: ''
      }
    };
  },
  computed: {
    serviceDateRange() {
      const { serviceStartMonth, serviceEndMonth } = this.surveyInfo;
      if (!serviceStartMonth || !serviceEndMonth) return '--';
      return `${this.formatMonth(serviceStartMonth)}~${this.formatMonth(serviceEndMonth)}`;
    }
  },
  created() {
    const saved = this.getSavedSurvey();
    if (saved.basic) {
      const { surveyCode: storedSurveyCode, ...basicForm } = saved.basic;
      this.form = Object.assign({}, this.form, basicForm);
    }
    if (saved.surveyInfo) {
      this.surveyInfo = saved.surveyInfo;
      this.surveyValid = true;
    }
    this.initializeSurvey();
  },
  methods: {
    getSavedSurvey() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      } catch (error) {
        return {};
      }
    },
    formatMonth(value) {
      return value ? value.slice(0, 7) : '';
    },
    async initializeSurvey() {
      const surveyCode = this.$route.query.surveyCode;
      if (!surveyCode) {
        Toast.fail('链接无效，无法进行下一步');
        return;
      }
      this.loading = true;
      try {
        const { data } = await getSurveyDateDetail({ surveyCode });
        this.surveyInfo = {
          serviceStartMonth: data.serviceStartMonth || '',
          serviceEndMonth: data.serviceEndMonth || ''
        };
        this.surveyValid = true;
        const saved = this.getSavedSurvey();
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, saved, {
          surveyCode,
          surveyInfo: this.surveyInfo
        })));
      } catch (error) {
        Toast.fail('链接无效，无法进行下一步');
      } finally {
        this.loading = false;
      }
    },
    nextPage() {
      if (!this.surveyValid) {
        Toast.fail('链接无效，无法进行下一步');
        return;
      }
      const emptyField = this.basicFields.find(field => !this.form[field.key]);
      if (emptyField) {
        Toast(`请填写${emptyField.label}`);
        return;
      }
      if (!/^\d{11}$/.test(this.form.phone)) {
        Toast('联系电话需为11位数字');
        return;
      }
      const saved = this.getSavedSurvey();
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(Object.assign({}, saved, {
        basic: Object.assign({}, this.form, { surveyCode: this.$route.query.surveyCode || saved.surveyCode })
      })));
      this.$router.push('/beecargo/satisfactionSurvey/form');
    }
  }
};
</script>

<style lang="scss" scoped>
.survey-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #ff733c 0, #ffb246 100%);
  color: #3d3833;
  padding-bottom: 76px;
  img {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.page-top {
    width: 100%;
    height: 188px;
    margin-bottom: 16px;
}
.page-header {
  height: 44px; background: #fff; display: flex; align-items: center; justify-content: center;
  font-size: 17px; position: relative; box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}
.back-button { position: absolute; left: 12px; border: 0; background: transparent; color: #3d3833; font-size: 32px; line-height: 1; padding: 0 6px 4px; }
.survey-content { padding: 0 0 12px; }
.form-content {padding: 0 12px;}
.hero {
  height: 188px; margin: 0 -12px 16px; padding: 22px 28px; overflow: hidden; position: relative;
  color: #f26d22; background: linear-gradient(145deg, #fffdf8, #ffe5c2 55%, #ff8b39);
}
.hero::after { content: ''; width: 440px; height: 90px; position: absolute; bottom: -43px; left: -25px; background: #ff681f; border-radius: 50% 50% 0 0; transform: rotate(-2deg); }
.hero-brand { font-size: 13px; color: #ee921e; font-weight: bold; }
.hero h1 { font-size: 25px; margin: 13px 0 4px; font-style: italic; }
.hero p { margin: 0; font-size: 11px; color: #716356; }
.hero-truck { position: absolute; right: 40px; bottom: 35px; font-size: 66px; z-index: 1; }
.notice-card, .basic-form { border-radius: 4px; overflow: hidden; background: #fff;position: relative; }
.notice-bg {
    width: 200px;
    height: 200px;
    position: absolute;
    top: 51px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    opacity: .4;
    img {
        width: 100%;
        height: 100%;
    }
}
.notice-title { padding: 4px 0 8px; background: #ffffff;border-radius: 4px 4px 0 0; }
.notice-bottom { width: 100%; height: 8px; background: #ff733c; }
.notice-title-text { padding: 10px 16px; background: #ff733c; color: #fff; font-size: 16px;border-radius: 4px 4px 0 0; }
.notice-body { padding: 8px 16px; font-size: 16px; line-height: 24px;z-index: 2; }
.notice-body p { margin: 0; }
.notice-body p + p { text-indent: 2em;position: relative;z-index: 2; }
.basic-form { 
    padding: 4px 16px;
    position: relative;
    .center-line {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 1px;
        font-size: 0;
        display: flex;
        justify-content: center;
    }
}
.form-item { display: block; padding: 12px 0 16px; border-bottom: 1px solid #eee5dc; }
.form-item:last-child { border: 0; }
.question { display: block; margin-bottom: 8px; font-size: 16px; }
.question i { color: #ff484a; font-style: normal; }
input { box-sizing: border-box; width: 100%; height: 42px; padding: 8px; border: 1px solid #d9cbbe; border-radius: 4px; color: #3d3833; font-size: 16px; outline: none; }
input:focus { border-color: #f1892e; }
.page-footer { position: fixed; z-index: 2; right: 0; bottom: 0; left: 0; padding: 6px 12px 10px; background: #fff; }
.primary-button { width: 100%; border: 0; border-radius: 4px; padding: 13px 16px; background: #f1892e; color: #fff; font-size: 14px; }

@media (min-width: 768px) {
  .survey-content {
    box-sizing: border-box;
    width: 720px;
    margin: 0 auto;
    padding-bottom: 28px;
  }
  .page-top {
    height: 361px;
  }
  .form-content {
    padding: 0;
  }
  .notice-card,
  .basic-form {
    border-radius: 8px;
  }
  .basic-form {
    margin-top: 16px;
    padding: 12px 32px;
  }
  .form-item {
    padding: 18px 0 22px;
  }
  .page-footer {
    box-sizing: border-box;
    right: auto;
    left: 50%;
    width: 720px;
    padding: 10px 0 14px;
    transform: translateX(-50%);
  }
  .primary-button {
    height: 48px;
    cursor: pointer;
  }
}
</style>
